import React from 'react'
import PropTypes from 'prop-types'
import { EducationAnalytics } from 'education-tools'
import {
  TitleSecondary,
  LinkSecondary,
  ParagraphSecondary,
  SpacerVertical
} from 'mage-deps/@klarna/bubble-ui'
import { Message } from 'mage-i18n'

EmailContact.propTypes = {
  articleId: PropTypes.string,
  emailAddress: PropTypes.string.isRequired
}

function EmailContact({ articleId, emailAddress }) {
  return (
    <>
      <EducationAnalytics
        category="uhqm/contact"
        action="print"
        referenceType={articleId ? 'article' : undefined}
        referenceId={articleId}
        label="email"
        googleAnalytics={false}
      />
      <EducationAnalytics
        category="uhqm/contact"
        action="click"
        referenceType={articleId ? 'article' : undefined}
        referenceId={articleId}
        label="email"
      >
        {track => (
          <>
            <TitleSecondary>
              <Message path="hqm.contact.email.title" fallback="Email us" />
            </TitleSecondary>
            <ParagraphSecondary>
              <Message
                path="hqm.contact.email.paragraph"
                fallback="Shoot us an email and we will get back to you as soon as we can."
              />
            </ParagraphSecondary>
            <LinkSecondary size="medium" href={`mailto:${emailAddress}`} onClick={() => track()}>
              {emailAddress}
            </LinkSecondary>
            <SpacerVertical large />
          </>
        )}
      </EducationAnalytics>
    </>
  )
}

export default EmailContact
